import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, forkJoin, of, switchMap, takeWhile } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

import { IPanel, PanelsService } from '@app/core/panels';
import { IReport, ReportsService } from '@app/core/reports';
import { CommentDialogComponent } from '../components/comment-dialog/comment-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-panel-detail',
  templateUrl: './panel-detail.component.html',
  styleUrls: ['./panel-detail.component.css'],
})
export class PanelDetailComponent implements AfterViewInit {
  @ViewChild('iframe') iframe: HTMLIFrameElement;

  private panel: IPanel;
  private destroyed: boolean;

  public reports$: BehaviorSubject<IReport[]> = new BehaviorSubject([]);

  public activeIndex: number | number[] = [];

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private panelService: PanelsService,
    private reportsService: ReportsService,
    private dialogService: DialogService
  ) {}
  ngAfterViewInit(): void {}

  setCookie(name: string, value: string, days: number) {
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000); // Expira en 'days' días
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/;Secure;SameSite=None`; // Asegúrate de que `SameSite=None` y `Secure` estén configurados
  }

  public ngOnInit(): void {
    this.panelService.getToken().subscribe(({ token }) => {
      console.log('Token:', token);
      // Llamar a esta función en Angular
      this.setCookie('acc', token, 1); // Establecer la cookie 'panel' a 'b'
    });
    this._loadPanels();
  }

  private _loadPanels(): void {
    this.route.data
      .pipe(
        switchMap((data) => of(data['panel'] as IPanel)),
        switchMap((panel) => {
          this.panel = panel;

          return forkJoin([
            this.reportsService.getReports(),
            this.panelService.getReportsByPanelId(panel.id),
          ]);
        }),

        switchMap((values) => {
          const [allReports, panelReports] = values;
          return of(
            allReports.filter((r) =>
              panelReports.some((pr) => pr.reportId === r.id)
            )
          );
        }),

        takeWhile(() => !this.destroyed)
      )
      .subscribe((reports) => {
        this.reports$.next(reports.map((r) => ({ ...r, visible: false })));
      });
  }

  public getSafeUrl(url: string): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public ngOnDestroy() {
    this.destroyed = true;
  }

  refreshIframe(iframe: HTMLIFrameElement): void {
    const src = iframe.src;
  }

  openCommentDialog(event, report: IReport): void {
    event.stopPropagation();
    // Aquí puedes implementar la lógica para abrir un diálogo de comentarios
    console.log('Abrir diálogo de comentarios para el informe:', event);
    this.dialogService
      .open(CommentDialogComponent, {
        height: '700px',
        width: '860px',
        modal: false,
        draggable: true,
        closable: true,
        maximizable: true,

        header: `Comentarios del informe ${report.title}`,
        data: {
          report,
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        this._loadPanels();
        console.log('Resultado del diálogo de comentarios:', result);
        if (result) {
          // Aquí puedes manejar el resultado del diálogo, como actualizar los comentarios
          console.log('Comentarios actualizados:', result);
        }
      });
  }

  onOpen(event) {
    console.log('onOpen', this.activeIndex, event);
    Array.isArray(this.activeIndex) && this.activeIndex.push(event.index);
    this.reports$.next(
      this.reports$.value.map((r, i) => {
        if (i === event.index) {
          return { ...r, visible: true };
        }
        return r;
      })
    );
  }
}
